<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="采购付款单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>采购付款单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="申请时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>申请时间:{{ parseTime(new Date(form.createdTime) ,"{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="申请人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申请人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" label="供应商" v-if="getIsView()">
                <el-select v-model="form.supplierName" :disabled="!editMode" placeholder="请选择供应商" filterable
                  :filter-method="getSuppliers" @change="supplierChange" style="width:100%">
                  <el-option key="0" label="请选择供应商" value></el-option>
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>供应商:{{ form.supplierName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="付款金额" v-if="getIsView()">
                <el-input disabled v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>付款金额:{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="stateName" label="状态" v-if="getIsView()">
                <el-input disabled v-model="form.stateName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>状态:{{ form.stateName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="remark" label="备注" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">发票明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick
              @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px"
            @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="billRegisterNo" label="发票登记单号">
              <template slot-scope="scope">
                <el-select v-if="editMode" v-model="scope.row.billRegisterNo" placeholder="请选择" :disabled="!editMode"
                  filterable :filter-method="getBillRegisterList" @change="billRegisterChange(scope.row)">
                  <el-option v-for="item in billRegisterList" :key="item.id" :label="item.no"
                    :value="item.id"></el-option>
                </el-select>
                <span v-else>{{ scope.row.billRegisterNo }}</span>
              </template>
              <!--          <template v-if="!editMode" slot-scope="scope">{{scope.row.billRegisterNo}}</template>-->
            </el-table-column>
            <el-table-column :show-overflow-tooltip="true" prop="billNo" label="发票号码" />
            <el-table-column prop="amount" label="开票金额" width="120">
            </el-table-column>
            <el-table-column prop="paymentAmount" label="已付款金额" width="120">
            </el-table-column>
            <el-table-column prop="unPaymentAmount" label="未付款金额" width="120">
            </el-table-column>
            <el-table-column prop="thisPaymentAmount" label="本次付款" width="120">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入本次付款" type="number" min="0"
                  @input='amountChange(scope.row)' v-model="scope.row.thisPaymentAmount"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入备注" v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {

  GetPaymentById,
  SavePayment,
  RejectPayment,
  GetBillRegisters
} from "@/api";
// import { BillTaxOptions, BillCategory, BillTableCategory } from "@/enum";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    ApproveInfo,
  },
  data() {
    return {
      GetDataAction: GetPaymentById,
      SaveDataAction: SavePayment,
      reject: RejectPayment,
      form: {},

      // taxList: BillTaxOptions,
      // billCategory: BillCategory,
      // billTableCategory: BillTableCategory,
      rules: {
        supplierName: [
          { required: true, message: '请选择供应商', trigger: 'blur' }
        ],
      },

      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      editMode: false,
      showWorkFlowInfo: false,

      billRegisterList: [],
    };
  },

  created() {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (query.isCopy == 1) {
      this.isCopy = true
    }

    // console.log('params', this.$route.params)
    let params = this.$route.params
    if (params) {
      let supplierId = params.supplierId
      let supplierName = params.supplierName
      let billRegisterArray = params.billRegisterArray

      if (supplierId != 0) {
        this.form.supplierId = supplierId
        this.form.supplierName = supplierName
      }
      if (billRegisterArray && billRegisterArray.length > 0) {
        billRegisterArray.map(item => {
          this.form.details.push({
            billRegisterId: item.id,
            billRegisterNo: item.no,
            billNo: item.billNo,
            amount: item.totalAmount,
            paymentAmount: item.receivedAmount,
            unPaymentAmount: item.unReceivedAmount,
            thisPaymentAmount: item.unReceivedAmount
          })

          this.autoTotalAmount()
        })
      }
    }


    // if (query.editMode == 1) {
    //   this.editMode = true
    // }

    this.getSuppliers('')
  },
  methods: {
    // 新建
    handleAdd() {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate(id) {
      this.GetDataAction({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);


      });
    },
    // 保存
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.form.details) {
          for (let i = 0; i < this.form.details.length; i++) {
            if (this.form.details[i].thisPaymentAmount > this.form.details[i].unPaymentAmount) {
              this.$my_message(`第${i + 1}行本次付款金额大于未付款金额`, 'warning')
              return
            }
          }
        }
        this.SaveDataAction(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        }).finally(() => {
          this.$store.dispatch('SetLoading', false)
        });;
      });
    },
    resetForm() {
      this.form = {
        state: 0,
        supplierName: '',
        supplierId: '',
        details: [],
        totalAmount: 0,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode: sessionStorage.getItem('orgId')
      };
    },
    // 取消编辑
    cancel() {
      this.$store.dispatch('SetLoading', false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm() {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.form.details.push(this.childForm)
      this.autoTotalAmount()

    },
    handleDeleteChildForm() {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange(selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick(row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
    },

    resetDetailFormData() {
      this.childForm = {
        $index: this.form.details.length + 1,
        "amount": 0,
        "paymentAmount": 0,
        "unPaymentAmount": 0,
        thisPaymentAmount: 0,
      };
    },
    cancelChildDialog() {
      this.openSubformModal = false;
    },
    submitChildForm() {
      this.pushChildForm(true);
    },
    continueAdd() {
      this.editChildren = false;
      this.pushChildForm();

      this.getProductList('')
    },
    pushChildForm(close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find(
            (e) => e.$index == this.childForm.$index
          );
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    amountChange(row) {
      this.autoTotalAmount();
    },
    autoAmount() {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount() {
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        totalAmount = totalAmount * 1 + element.thisPaymentAmount * 1;
      });
      this.form.totalAmount = totalAmount.toFixed(4) * 1
    },

    // change event 
    supplierChange(val) {
      var arr = this.STATIC_Suppliers.filter(e => e.id == val)
      this.form.supplierId = arr[0].id
      this.form.supplierName = arr[0].name
      this.getBillRegisterList('')

      this.form.details = []
      this.billDetailList = []
      // if (!this.form.supplierId) {
      //   return;
      // }
    },
    billRegisterChange(row) {
      row.billRegisterId = row.billRegisterNo
      let arr = this.billRegisterList.filter(e => e.id == row.billRegisterId)
      if (arr && arr.length > 0) {
        // row.billRegisterNo = arr[0].no
        row.billNo = arr[0].billNo
        row.amount = arr[0].totalAmount
        row.paymentAmount = arr[0].receivedAmount
        row.unPaymentAmount = arr[0].unReceivedAmount
        row.thisPaymentAmount = arr[0].unReceivedAmount
      }
    },

    getBillRegisterList(keyWord) {
      if (!this.form.supplierId) {
        this.billRegisterList = []
        return;
      }

      GetBillRegisters({ keyWord: keyWord, pageSize: 100, pageIndex: 1, supplierId: this.form.supplierId, states: [1, 2], status: 2 })
        .then(res => {
          this.billRegisterList = res.returnData.data
        })
    }
  },
};
</script>

<style lang="scss" scoped>
// /deep/.el-dialog__body {
//   overflow: auto !important;
// }
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
